export enum ButtonType {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
  TERTIARY = 'TERTIARY',
  OUTLINE = 'OUTLINE',
  AS_TEXT = 'AS_TEXT'
}
